export enum CRUDOPTIONS {
    DELETE = "DELETE",
    PUT = "PUT"
}